/** Extract IATA code from strings like "New York (JFK)" */
export function extractIataCode(location = '') {
  const paren = location.match(/\(([A-Z]{3})\)/i);
  if (paren) return paren[1].toUpperCase();

  const trimmed = location.trim();
  if (/^[A-Z]{3}$/i.test(trimmed)) return trimmed.toUpperCase();

  const CITY_MAP = {
    'new york': 'JFK',
    'los angeles': 'LAX',
    chicago: 'ORD',
    miami: 'MIA',
    atlanta: 'ATL',
    london: 'LHR',
    paris: 'CDG',
    dubai: 'DXB',
    tokyo: 'NRT',
    mumbai: 'BOM',
    bangkok: 'BKK',
    sydney: 'SYD',
    toronto: 'YYZ',
    boston: 'BOS',
    denver: 'DEN',
    seattle: 'SEA',
    'san diego': 'SAN',
    orlando: 'MCO',
    amsterdam: 'AMS',
    barcelona: 'BCN',
    rome: 'FCO',
    singapore: 'SIN',
    'las vegas': 'LAS',
    'san francisco': 'SFO',
  };

  const key = trimmed
    .toLowerCase()
    .replace(/\s*\([^)]*\)\s*/g, '')
    .replace(/,.*$/, '')
    .trim();
  if (CITY_MAP[key]) return CITY_MAP[key];

  const codeInParens = trimmed.match(/\(([A-Z]{3})\)/i);
  if (codeInParens) return codeInParens[1].toUpperCase();

  return trimmed.slice(0, 3).toUpperCase();
}
